import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Wallet, TrendingUp, TrendingDown, Trophy, AlertTriangle, Layers } from 'lucide-react';

export function MultiWalletStats() {
  // Mock stats - will be replaced with real aggregated data
  const stats = {
    totalWallets: 4,
    activeWallets: 4,
    totalValue: '125,847.32',
    change24h: '+4,523.15',
    change24hPercent: 3.72,
    bestPerformer: {
      walletLabel: 'Trading Wallet',
      change24hPercent: 8.5,
    },
    worstPerformer: {
      walletLabel: 'Cold Storage',
      change24hPercent: -1.2,
    },
    mostDiversified: {
      walletLabel: 'Main Wallet',
      tokenCount: 15,
    },
  };

  const isPositive = stats.change24hPercent >= 0;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
      {/* Total Wallets */}
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Wallets Conectadas</p>
              <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                {stats.totalWallets}
              </p>
            </div>
            <div className="p-2 bg-violet-500/20 rounded-lg">
              <Wallet className="h-5 w-5 text-violet-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Total Value */}
      <Card className="col-span-2">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Valor Total Agregado</p>
              <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                ${stats.totalValue}
              </p>
              <p className={`text-sm flex items-center gap-1 ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
                {isPositive ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
                {stats.change24h} ({stats.change24hPercent}%)
              </p>
            </div>
            <div className={`p-2 rounded-lg ${isPositive ? 'bg-green-500/20' : 'bg-red-500/20'}`}>
              {isPositive ? (
                <TrendingUp className="h-5 w-5 text-green-500" />
              ) : (
                <TrendingDown className="h-5 w-5 text-red-500" />
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Best Performer */}
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Mejor Rendimiento</p>
              <p className="text-lg font-bold text-slate-900 dark:text-slate-100 truncate">
                {stats.bestPerformer.walletLabel}
              </p>
              <p className="text-sm text-green-500">
                +{stats.bestPerformer.change24hPercent}%
              </p>
            </div>
            <div className="p-2 bg-green-500/20 rounded-lg">
              <Trophy className="h-5 w-5 text-green-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Worst Performer */}
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Menor Rendimiento</p>
              <p className="text-lg font-bold text-slate-900 dark:text-slate-100 truncate">
                {stats.worstPerformer.walletLabel}
              </p>
              <p className="text-sm text-red-500">
                {stats.worstPerformer.change24hPercent}%
              </p>
            </div>
            <div className="p-2 bg-red-500/20 rounded-lg">
              <AlertTriangle className="h-5 w-5 text-red-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Most Diversified */}
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Mas Diversificada</p>
              <p className="text-lg font-bold text-slate-900 dark:text-slate-100 truncate">
                {stats.mostDiversified.walletLabel}
              </p>
              <p className="text-sm text-slate-600 dark:text-slate-400">
                {stats.mostDiversified.tokenCount} tokens
              </p>
            </div>
            <div className="p-2 bg-blue-500/20 rounded-lg">
              <Layers className="h-5 w-5 text-blue-500" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
